// result
export var XBPM_CANCELATION = Symbol('cancelation');
export var XBPM_ERROR_KIND = Symbol('$kind');
export var XbpmErrorType;
(function (XbpmErrorType) {
    XbpmErrorType["SYSTEM"] = "SYSTEM";
    XbpmErrorType["BUSINESS"] = "BUSINESS";
})(XbpmErrorType || (XbpmErrorType = {}));
//# sourceMappingURL=common.types.js.map